import { OnRaceBetsSchema } from './OnRaceBets.styles';

export const onRaceBetStyles: OnRaceBetsSchema = {
  wrapper: {
    mb: '2',
    bg: 'beta.200',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.35)',
    border: 'node',
    borderRadius: 'md',
    flexDirection: 'column',
    py: '2',
  },
  headerWrapper: {
    px: '3',
    flexDirection: 'row',
    alignItems: 'center',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
    borderBottom: '1px',
    borderColor: 'rgba(0, 0, 0, 0.25)',
  },
  headerText: {
    fontSize: 'sm',
    fontWeight: 'normal',
    fontFamily: 'accent',
    color: 'white',
  },
  headerCountText: {
    ml: '1',
    fontSize: '2xs',
    fontWeight: 'semibold',
    color: 'gamma.300',
  },
  headerExpandButton: {
    variant: 'unstyled',
    ml: 'auto',
    mr: '1',
    color: 'beta.500',
    boxSize: '7',
  },
  toggleIcon: {
    boxSize: '4',
    color: 'gamma.300',
  },
  betsContainer: {
    flexDirection: 'column',
  },
  betCategoryWrapper: {
    alignItems: 'center',
    mt: '2',
  },
  betCategory: {
    fontSize: 'sm',
    fontWeight: 'semibold',
    color: 'alpha.700',
  },
  betCategoryCount: {
    fontSize: 'xs',
    fontWeight: 'semibold',
    color: 'alpha.700',
    ml: '1',
  },
  divider: {
    display: 'none',
  },
  betRow: {
    p: '2',
    gap: '2',
    mt: '1',
    bg: 'blackAlpha.300',
    borderRadius: 'base',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
  },
  betRowDivider: {
    borderBottomWidth: '1px',
    borderBottomColor: 'blackAlpha.200',
    borderBottomStyle: 'dashed',
  },
  groupDivider: {
    borderBottomWidth: '1px',
    borderBottomColor: 'blackAlpha.400',
  },
  categoryIcon: {
    color: 'gamma.400',
    boxSize: '6',
  },
  groupContainer: {
    flexDir: 'column',
    py: 2,
    px: '3',
    border: 'none',
    boxShadow: 'none',
    _last: {
      boxShadow: 'none',
    },
  },
  groupTitleText: {
    color: 'gamma.300',
    fontSize: 'sm',
    fontWeight: 'normal',
    fontFamily: 'accent',
  },
  runnerText: {
    color: 'white',
    fontSize: 'sm',
    fontWeight: 'extrabold',
    textTransform: 'capitalize',
  },
  runnerBarrierText: {
    color: 'white',
    fontSize: 'xs',
  },
  stakeText: {
    color: 'gamma.300',
    fontSize: 'xs',
    fontWeight: 'black',
    pl: '5',
  },
  potentialWinningsText: {
    color: 'gamma.300',
    fontSize: 'xs',
    fontWeight: 'black',
    pl: '5',
  },
  subtitleText: {
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'normal',
  },
  exoticsPositionText: {
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'extrabold',
    w: 9,
  },
  viewMoreButton: {
    alignItems: 'center',
    justifyContent: 'center',
    mb: -2,
    borderTopRadius: 0,
    height: 8,
  },
  viewMoreButtonText: {
    fontWeight: 'normal',
    fontSize: 'sm',
    textTransform: 'uppercase',
    pt: '1',
  },
  srmBlendedLegContainer: {
    flexDir: 'row',
    flex: '1',
  },
  srmBlendedRunnerText: {
    width: 32,
    fontWeight: 'bold',
    color: 'white',
    fontSize: 'xs',
    textTransform: 'capitalize',
  },
  srmMarketText: {
    fontWeight: 'normal',
    color: 'white',
    fontSize: 'xs',
  },
  srmBlendedWrapper: {
    flexDir: 'column',
    flex: 1,
  },
  flexiText: {
    fontWeight: 'bold',
    color: 'white',
    fontSize: 'xs',
  },
  flexiStakeText: {
    width: '16',
    fontSize: 'xs',
    color: 'white',
    fontWeight: 'bold',
  },
  flexiStakeValueText: {
    color: 'white',
  },
};
